import { useForm, UseFormOptions } from 'react-hook-form';

import { FilterValues } from './types';

export const useFilterForm = <T extends FilterValues = FilterValues>(
  defaultValues?: T,
  options?: Omit<UseFormOptions<T>, 'defaultValues' | 'mode'>,
) => {
  return useForm<T>({
    mode: 'onChange',
    defaultValues: defaultValues as UseFormOptions<T>['defaultValues'],
    ...options,
  });
};
